import {axios} from "@/lib/axios";
import { SortPostParams } from "@/containers/admin/Layers/Layers"

export const getLayers = (params: {
  sort_column_name: string | null;
  sort_order: number | null;
}) => {
  return axios.get("/api/v1/layers/getLayers", {
    params,
  });
};

export const deleteLayer = (id: number) => {
  return axios.post(`/api/v1/layers/deleteLayer`, {id});
}

export const postLayer = (id: number, name: string, url: string) => {
  return axios.post(`/api/v1/layers/postLayer`, {id, name, url})
}